function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLetterConfirm = function SvgLetterConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.482 101.482"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M61.765 28.906v.9L55 35.638V20.28l4.212 3.332a6.786 6.786 0 0 1 2.553 5.294z",
    style: {
      fillRule: "evenodd",
      fill: "#7facfa"
    },
    transform: "translate(38.026 14.021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.959 25.91v49.2a6.671 6.671 0 0 1-2.25 5.023l-31.9-24.8 27.384-23.588z",
    style: {
      fill: "#e8edfc",
      fillRule: "evenodd"
    },
    transform: "translate(26.832 17.913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2 30.291v44.821a6.709 6.709 0 0 1-.487 2.449l3.312 2.574a6.671 6.671 0 0 0 2.25-5.023V25.91z",
    style: {
      fill: "#cad9fc",
      fillRule: "evenodd"
    },
    transform: "translate(38.518 17.913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.931 72.466a6.738 6.738 0 0 1-4.516 1.742H6.846a6.739 6.739 0 0 1-4.516-1.742l31.9-24.8 12.8-9.945a3.4 3.4 0 0 1 4.195 0l12.8 9.945z",
    style: {
      fill: "#e8edfc",
      fillRule: "evenodd"
    },
    transform: "translate(1.611 25.583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.149 55.34-31.9 24.8A6.671 6.671 0 0 1 1 75.112V25.91l6.766 5.835z",
    style: {
      fill: "#e8edfc",
      fillRule: "evenodd"
    },
    transform: "translate(.691 17.913)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.765 20.28v15.358L1 29.8v-.9a6.786 6.786 0 0 1 2.554-5.294z",
    style: {
      fillRule: "evenodd",
      fill: "#7facfa"
    },
    transform: "translate(.691 14.021)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.569 4.383v44.584L62.185 72.562l-12.8-9.945a3.4 3.4 0 0 0-4.195 0l-12.8 9.945L5 48.967V4.383A3.393 3.393 0 0 1 8.383 1h77.8a3.393 3.393 0 0 1 3.386 3.383z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(3.457 .691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9 1h-5.073a3.393 3.393 0 0 1 3.383 3.383v44.584L37.232 70.488l2.668 2.074 27.384-23.595V4.383A3.393 3.393 0 0 0 63.9 1",
    style: {
      fill: "#cad9fc",
      fillRule: "evenodd"
    },
    transform: "translate(25.741 .691)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5,
    cy: 24,
    rx: 23.5,
    ry: 24,
    style: {
      fill: "#26d980"
    },
    transform: "translate(27.154 8.328)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.037 5a23.464 23.464 0 0 0-2.537.142 23.965 23.965 0 0 1 0 47.587 23.584 23.584 0 0 0 22.175-10.364 24.155 24.155 0 0 0 1.311-24.659A23.645 23.645 0 0 0 31.037 5",
    style: {
      fill: "#9cfacb",
      opacity: 0.7,
      fillRule: "evenodd"
    },
    transform: "translate(19.704 3.457)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.131 36.7a3.366 3.366 0 0 1-2.392-.991l-6.765-6.769a3.383 3.383 0 0 1 4.783-4.783l4.374 4.372 14.522-14.52a3.383 3.383 0 1 1 4.783 4.783L33.523 35.705a3.366 3.366 0 0 1-2.392.991z",
    style: {
      fill: "#e8edfc",
      fillRule: "evenodd"
    },
    transform: "translate(14.536 8.971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47h3.383v13.531H0z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(0 32.495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.286 36.307-3.569-2.818V5.074A5.074 5.074 0 0 0 89.643 0H11.84a5.074 5.074 0 0 0-5.075 5.074v28.415L3.19 36.312A8.435 8.435 0 0 0 0 42.927v50.568a1.691 1.691 0 0 0 3.383 0V47.512l29.792 25.675-29 22.544a5.03 5.03 0 0 1-.793-2.706 1.691 1.691 0 1 0-3.383 0 8.467 8.467 0 0 0 8.457 8.457h84.57a8.467 8.467 0 0 0 8.457-8.457v-50.1a8.438 8.438 0 0 0-3.197-6.618M98.1 93.026a5.03 5.03 0 0 1-.793 2.706l-29-22.544L98.1 47.512zm-1.918-54.072a5.062 5.062 0 0 1 1.918 3.973v.122l-3.383 2.916V37.8zm-92.8 3.973a5.059 5.059 0 0 1 1.911-3.968L6.765 37.8v8.169l-3.382-2.92zm6.765 5.954V5.074a1.691 1.691 0 0 1 1.693-1.691h77.8a1.691 1.691 0 0 1 1.691 1.691v43.807L65.583 71.072l-11.7-9.1a5.093 5.093 0 0 0-6.273 0l-11.71 9.1zM8.457 98.1a5.009 5.009 0 0 1-1.5-.252l42.727-33.207a1.717 1.717 0 0 1 2.118 0l42.724 33.2a5.008 5.008 0 0 1-1.5.255z",
    style: {
      fill: "#0068ff"
    }
  }));
};
export default SvgLetterConfirm;